<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown no-flip name="tab-items">
                <template slot="button-content">
                    <i class="cus-page-white-text"></i>
                    Items ({{ tabCount }})
                </template>
                <div>
                    <b-dropdown-item @click="displayList()">
                        <i class="cus-page-white-text"></i>
                        View Items
                    </b-dropdown-item>
                </div>
                <template v-if="isAbleToAddItem">
                    <li class="dropdown-divider"></li>

                    <div>
                        <b-dropdown-item @click.stop="addItem">
                            <i class="cus-add"></i>
                            New Item
                        </b-dropdown-item>
                    </div>
                </template>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <item-list
                ref="itemList"
                :key="keyview"
                v-on="$listeners"
                @reload-details="reloadDetails"
            />
        </b-card-text>
    </b-tab>
</template>

<script>
import ItemList from "@/components/setting-template/wellness-plan/item-list";

export default {
    components: {
        ItemList
    },
    data() {
        return {
            keyview: 0,
            isDeleteMultiple: false,
            isSelected: false,
            selectLength: 0,
            totalItems: 0
        };
    },
    props: {
        tabCount: {
            type: Number,
            default: 0
        },
        estimate: {
            type: Object,
            required: false
        }
    },
    computed: {
        templateId() {
            return this.$store.state.settingsTemplate.templateId;
        },
        isAbleToAddItem() {
            return (
                Number(
                    this.$store.state.settingsTemplate.details
                        .wellness_plan_enrollees
                ) <= 0
            );
        }
    },
    methods: {
        displayList() {
            this.keyview += 1;
            this.$emit("reload-tab-count");
        },
        addItem() {
            this.$store.dispatch("settingsTemplate/openModalItem", {
                isEdit: false,
                item: null
            });
        },
        reloadItem() {
            // Render getItems when the itemList already rendered
            if (this.$refs.itemList) {
                this.$refs.itemList.getItems();
            }
        },
        async createBundle() {
            this.$parent.$parent.$refs.modalItemBundle.open();
        },
        reloadDetails() {
            this.$emit("reload-item-details");
        }
    }
};
</script>
